//import { Fab, Action } from 'react-tiny-fab';
//import 'react-tiny-fab/dist/styles.css';
import { FaFacebook, FaInstagram, FaWhatsapp } from 'react-icons/fa';
import './FloatingButton.css';
import React, { useState, useEffect } from "react";

export default function MainFloatingButton() {
    const fabStyle = {
        backgroundColor: "#164E63",
    }

    const handelWhastsAppOnClick = () => {
        window.open('https://wa.link/whyy10', '_blank');
    }

    const handelFacebookClick = () => {
        window.open('https://www.facebook.com/fookchongliving/', '_blank');
    }
    const handelInstagramOnclik = () => {
        window.open('https://www.instagram.com/fookchong_wtsapp_92374820/', '_blank');
    }
    return (
        <>
            {/* <Fab
                icon={<svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path></svg>}
                alwaysShowTitle = {true}
                mainButtonStyles = {fabStyle}
                event="hover"
            >
                <Action text="WhatsApp" onClick={handelWhastsAppOnClick}>
                    <img src='/images/mediaIcon/whatsapp.png' className='rounded-full'/>
                </Action>
                <Action text="Facebook" onClick={handelFacebookClick}>
                    <img src='/images/mediaIcon/facebook.png' className='rounded-full' />
                </Action>
                <Action text="Instagram" onClick={handelInstagramOnclik}>
                    <img src='/images/mediaIcon/instagram.png' className='rounded-full' />
                </Action>
            </Fab> */}

            <div className="fabSelf">
                {/* <div className='fab-item'>
                    <span>Facebook 另外一個</span>
                    <a href="https://www.facebook.com/">
                        <img src='/images/mediaIcon/facebook.png' className='rounded-full h-12' />
                    </a>
                </div> */}
                <div className='fab-item'>
                    <span>Facebook</span>
                    <a href="https://www.facebook.com/">
                        <img src='/images/mediaIcon/facebook.png' className='rounded-full h-8' />
                    </a>
                </div>
                <div className='fab-item'>
                    <span>Instagram</span>
                    <a href="https://www.instagram.com/">
                        <img src='/images/mediaIcon/instagram.png' className='rounded-full h-8' />
                    </a>
                </div>
                <div className='fab-item'>
                    <span>WhatsApp</span>
                    <a href="https://www.whatsapp.com/">
                        <img src='/images/mediaIcon/whatsapp.png' className='rounded-full h-8' />
                    </a>
                </div>
            </div>
        </>
    );
}